import React from 'react';
import styled from 'styled-components';

import { createCollecticon } from '../collecticon-creator';

export const CollecticonSquareSmall = styled(
  createCollecticon((props) => (
    <svg {...props}>
      <title>{props.title || 'square small icon'}</title>
      <rect x='4' y='4' width='8' height='8' />
    </svg>
  ))
)`
  /* icons must be styled-components */
`;
